module.exports = __webpack_public_path__ + "img/logo-feedback-black.77852519.png";